import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminTable from '../AdminTable';
import { MODELS, MODEL_INITIAL_VALUES } from '../../../constants/admin/settings';
import { fetchEventEmails, saveEventEmail } from '../../../actions/admin/models/event.emails';
import EmailEditor from '../../../components/admin/forms/emails/EmailEditor';
import { setModelData, onInput } from '../../../actions/admin/forms';
import { formDataSelector } from '../../../selectors/admin/forms';
import EventEmailSenders from './EventEmailSenders';
import { TABLE_INDICES } from '../../../constants/admin/tables';
import { eventSenderOptionsSelector } from '../../../selectors/admin/models/event.emails';
import EventMailsFilter from '../../../components/admin/forms/events/EventMailsFilter';
import { filtersSelector } from '../../../selectors/admin/tables';

class EventEmails extends Component {
    _fetchEmails = () => {
        this.props.fetchEventEmails(this.props.eventId, this.props.filters);
    };
    _openEmail = data => this.props.setModelData(MODELS.EVENT_EMAIL, data);
    _cancelEdit = () => this.props.setModelData(MODELS.EVENT_EMAIL, MODEL_INITIAL_VALUES[MODELS.EVENT_EMAIL]);
    _onInput = (v, f) => this.props.onInput(MODELS.EVENT_EMAIL, f, v);

    render() {
        return this.props.emailOpen.id ? (
            <div className="u-margin-top-1">
                <EmailEditor
                    onSave={this.props.saveEventEmail}
                    onInput={this._onInput}
                    onCancel={this._cancelEdit}
                    email={this.props.emailOpen}
                    senderOptions={this.props.senderOptions}
                />
            </div>
        ) : (
            <React.Fragment>
                <EventEmailSenders eventId={this.props.eventId} />
                <AdminTable
                    AdvancedSearchForm={EventMailsFilter}
                    openItem={this._openEmail}
                    forceNoSelect={true}
                    fetchDataFunction={this._fetchEmails}
                    disableButtonAction={true}
                    model={MODELS.EVENT_EMAIL}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    filters: filtersSelector(state),
    senderOptions: eventSenderOptionsSelector(state, { tableIndex: TABLE_INDICES[MODELS.EVENT_EMAIL_SENDER] }),
    emailOpen: formDataSelector(state, { model: MODELS.EVENT_EMAIL })
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ fetchEventEmails, setModelData, onInput, saveEventEmail }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EventEmails);



// WEBPACK FOOTER //
// ./src/containers/admin/events/EventEmails.js